/* eslint-disable require-jsdoc */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DemoResponses: ()=>DemoResponses,
    DemoFetchApi: ()=>DemoFetchApi
});
const _get = /*#__PURE__*/ _interopRequireDefault(require("lodash/get"));
const _set = /*#__PURE__*/ _interopRequireDefault(require("lodash/set"));
const _ = require("..");
const _demoResponsesJson = /*#__PURE__*/ _interopRequireDefault(require("./demo-responses.json"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Regular expressions as strings, for example:
 *
 * @example
 *
 * {
 *      '/some/url/.{3,6}/edit': 'some.response.path',
 *      'POST:.+/v1/member/[a-z0-9]+': 'member.update'
 * }
 *
 */ const regexResMapping = {
    'POST:.+/join/v1/member_access_codes': 'join.phone',
    'GET:.+/join/v1/member_access_codes': 'join.pin',
    'GET:.+/wallet/v1/members/[a-z0-9]+': 'wallet.get_member',
    '/wallet/v2/members/[a-z0-9]+/milestones': 'wallet.milestones',
    '/native_app/v1/merchant_organizations': 'native_app.all_locations',
    '/native_app/v2/stashboard.member_id=': 'native_app.stashboard_keys',
    '/native_app/v1/stashboard/[a-z0-9]+': 'native_app.stashboard',
    '/native_app/v1/reward_redemptions.member_id=': 'native_app.reward_redemptions',
    '/native_app/v1/visits.member_id=': 'native_app.visits',
    '/wallet/v1/members/[a-z0-9]+/redemptions': 'wallet.redemptions',
    'PATCH:.+/native_app/v2/members': 'native_app.update_member',
    // TODO: update data
    'POST:.+/native_app/v1/members': 'native_app.create_member'
};
const DemoResponses = new Map(Object.entries(regexResMapping).map(([r, k])=>[
        new RegExp(r, 'i'),
        k
    ]));
/**
 * For giving the effect of a real API call
 * @returns
 */ const randomWait = ()=>{
    const max = 300;
    const min = 150;
    const n = Math.floor(Math.random() * (max - min + 1) + min);
    return new Promise((res)=>setTimeout(res, n));
};
class DemoFetchApi {
    oldDemoResponse = null;
    constructor(){
        this.demoResponses = _demoResponsesJson.default;
        this.fetchDemoResponses();
    }
    async fetchDemoResponses() {
        await randomWait();
        this.demoResponses = _demoResponsesJson.default;
    }
    async fetchClientDemoRes(client) {
        try {
            const res = await fetch(`${_.SETTINGS_URL}/${client}/demo-responses.json`);
            const payload = await res.json();
            this.oldDemoResponse = this.demoResponses;
            this.demoResponses = payload;
        } catch (e) {}
    }
    /**
     * Allows you the ability to set a value in the responses
     * that have been loaded into memory. Like this, we can
     * simulate API updates and change the values on the fly
     * before they are returned as a JSON response. This can
     * be accomplished with the `demo-will-fetch` event.
     * @param path
     * @param value
     * @returns
     */ setInDemoResponses(path, value) {
        const current = (0, _get.default)(this.demoResponses, path);
        // Merge the objects
        if (typeof value === 'object' && typeof current === 'object') {
            (0, _set.default)(this.demoResponses, path, {
                ...current,
                ...value
            });
            return;
        }
        (0, _set.default)(this.demoResponses, path, value);
    }
    /**
     * Simulates an Fetch API request, but instead returns an
     * object from demo payloads
     * @param url url
     * @param init request options
     * @returns
     */ async fetch(url, init) {
        const keys = DemoResponses.keys();
        const { method  } = init || {};
        let response = new Response();
        for (const regex of keys){
            const testUrl = `${method}: ${url}`;
            if (regex.test(testUrl)) {
                await _.observer.emit('demo-will-fetch', {
                    method: method,
                    opts: init,
                    url: testUrl
                });
                const path = DemoResponses.get(regex);
                const payload = (0, _get.default)(this.demoResponses, path);
                response = new Response(JSON.stringify(payload), {
                    headers: {
                        'content-type': 'application/json'
                    },
                    status: 200
                });
            }
        }
        await randomWait();
        return response;
    }
}
